class BlockedInboundEmailAddresses {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/blocked-inbound-email-addresses`;

  }

  async blockInboundEmailAddresses(emails) {

    const path = this.basePath;

    return this.apiClient.post(path, {}, {}, { emails });

  }

  async getBlockedInboundEmailAddressesByQueryOptions(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async deleteBlockedEmailById(blockedEmailId) {

    const path = `${this.basePath}/:blockedEmailId`;

    return this.apiClient.delete(path, { blockedEmailId }, {});

  }

}

export default BlockedInboundEmailAddresses;